<template>
    <div>
        <b-row>
            <b-col>
                <strong>Patient Name: </strong>{{ consultation.patientName }} <br>
                <strong>Phone Number: </strong>{{ consultation.phoneNumber | formatPhone }}
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <strong>Created By: </strong>{{ consultation.createdBy }}
            </b-col>
        </b-row>
        <b-row v-if="consultation.closedBy">
            <b-col>
                <strong>Closed By: </strong>{{ consultation.closedBy }}
            </b-col>
        </b-row>
        <b-row v-if="consultation.type == 0 || consultation.type">
            <b-col>
                <strong>Type: </strong>
                {{ ConsultationType[consultation.type] }}
            </b-col>
        </b-row>
        <b-row v-if="consultation.category == 0 || consultation.category">
            <b-col>
                <strong>Category: </strong>
                {{ ConsultationCategory[consultation.category] }}
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <NotesList ref="notesList" :entity-id="consultation.id" :entity-type="EntityType.Consultation"
                    :paging="false" :page-size="10000" />
                <NotesForm :entity-id="consultation.id" :entity-type="EntityType.Consultation" @saved="noteSaved" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <strong>Is the consultation complete? </strong>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <n-radio v-model="completed" label="true" :disabled="!enableEdit">YES</n-radio>
            </b-col>
            <b-col>
                <n-radio v-model="completed" label="false" :disabled="!enableEdit">NO</n-radio>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <strong>Was the consultation clinical? </strong>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <n-radio v-model="isClinical" label="true" :disabled="!enableEdit">YES</n-radio>
            </b-col>
            <b-col>
                <n-radio v-model="isClinical" label="false" :disabled="!enableEdit">NO</n-radio>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <SearchComponent :disabled="!enableEdit" :id="prescription?.id" v-model="prescription"
                    :search-u-r-l="'/patient/' + consultation.patientId + '/prescriptions'" prepopulate
                    label="Prescription"
                    :option-label="(e) => e.rxNumber ? `RxNumber: ${e.rxNumber} &middot; ${e.drugName}` : ''"
                    :params="{ excludeRefills: true, storeId: consultation.storeId }" clearable />
            </b-col>
        </b-row>
        <b-row v-if="this.consultation.completionQuestionSetId">
            <b-col>
                <hr>
                <TaskQuestions ref="questions" :questions="questions" :answers="answers" :show-errors="showErrors"
                    :disabled="!enableEdit" :entity-type="EntityType.Consultation" />
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator';
import { Consultation, ConsultationCategory, ConsultationType } from '@/models/Consultation';
import NRadio from "src/components/Inputs/Radio.vue";
import { Prescription } from '@/models/Prescription';
import SearchComponent from '@/components/SearchComponent.vue';
import TaskQuestions from '@/components/Tasks/TaskQuestions.vue';
import { UserTaskAnswer, UserTaskQuestion } from '@/models/UserTask';
import NotesList from '@/components/Note/NotesList.vue';
import NotesForm from '@/components/Note/NotesForm.vue';
import { EntityType } from '@/models/EntityType';

@Component({
    name: "CompleteConsultationComponent",
    components: {
        NRadio,
        SearchComponent,
        TaskQuestions,
        NotesList,
        NotesForm
    }
})
export default class CompleteConsultationComponent extends Vue {
    @Prop() private consultation!: Consultation;
    @Prop() private enableEdit!: boolean;
    @Prop() private questions!: UserTaskQuestion[];
    @Prop() private answers!: UserTaskAnswer[];
    @Prop({ default: false }) private showErrors!: boolean;

    @Ref("questions") protected questionComponent?: TaskQuestions;

    private completed = 'false';
    private isClinical = 'false';
    private prescription: Prescription | null = null;

    ConsultationType = ConsultationType;
    ConsultationCategory = ConsultationCategory;
    EntityType = EntityType;

    async mounted() {
        console.log("%c Created CompleteConsultationComponent", "color: green");
        this.completed = this.consultation.status == 4 ? 'true' : 'false';
        this.isClinical = this.consultation.clinical ? 'true' : 'false';
        this.prescription = Object.assign(new Prescription(), { rxNumber: this.consultation.rxNumber, drugName: this.consultation.drugName });
    }

    beforeDestroy() {
        console.log('%c Destroying CompleteConsultationComponent', 'color: red');
    }

    @Watch('completed')
    updateStatus() {
        this.consultation.status = this.completed == 'true' ? 4 : 2;
    }

    @Watch('isClinical')
    updateClinical() {
        this.consultation.clinical = this.isClinical == 'true';
    }

    @Watch('prescription')
    updatePrescription() {
        this.consultation.rxNumber = this.prescription?.rxNumber;
    }

    getCleanQuestionAnswers() {
        return this.questionComponent?.cleanAnswers();
    }

    getAnswersHaveErrors() {
        return this.questionComponent?.answersHaveErrors();
    }

    noteSaved() {
        this.loadNotes();
    }

    loadNotes() {
        if (this.$refs.notesList instanceof NotesList)
            this.$refs.notesList.loadNotes();
    }
}
</script>
